/* eslint no-use-before-define: 0 */

import jQuery from "jquery";
import Rx from "rxjs/Rx";

const calculatorValueSelectedSource = new Rx.Subject();
// {min, max}
const calculatorValueSelected$ = calculatorValueSelectedSource.asObservable();
export default calculatorValueSelected$;

(function main($) {
    $(document).ready(() => {
        const calculatorElements = $(".office-floor-space-calculator");
        if (calculatorElements.length) {
            calculatorElements.each(function initElement() {
                const spaceRange = $(this).find(".space-range").first();
                const spaceRangeContainer = $(this).find(".space-range-container").first();

                const openSpaceElement = $(this).find(".open-space-floor-space");
                const officesElement = $(this).find(".offices-floor-space");
                const combinationElement = $(this).find(".combination-floor-space");

                let calculatorInputChangeTimeoutId;
                $(document).on("change input", ".office-floor-space-calculator-input", function initTimer() {
                    window.clearTimeout(calculatorInputChangeTimeoutId);
                    calculatorInputChangeTimeoutId = window.setTimeout(calculatorInputChangeHandler, 100, $(this));
                });

                function calculatorInputChangeHandler(calculatorInput) {
                    let numberOfPeople = calculatorInput.val();
                    if (numberOfPeople < 0) {
                        numberOfPeople = 0;
                    }

                    const openSpaceValue = calculateFloorSpace(15, numberOfPeople);
                    const officesSpaceValue = calculateFloorSpace(22.6, numberOfPeople);
                    const combinationSpaceValue = calculateFloorSpace(16.5, numberOfPeople);

                    openSpaceElement.html(openSpaceValue);
                    officesElement.html(officesSpaceValue);
                    combinationElement.html(combinationSpaceValue);

                    const maxRangeValue = Math.max(openSpaceValue, officesSpaceValue, combinationSpaceValue);
                    const minRangeValue = Math.min(openSpaceValue, officesSpaceValue, combinationSpaceValue);

                    calculatorValueSelectedSource.next({
                        min: minRangeValue,
                        max: maxRangeValue,
                    });

                    if (maxRangeValue === 0 && minRangeValue === 0) {
                        spaceRangeContainer.attr("hidden", "true");
                        return;
                    }

                    if (maxRangeValue !== minRangeValue) {
                        spaceRange.html(`${minRangeValue} - ${maxRangeValue}`);
                    } else {
                        spaceRange.html(minRangeValue);
                    }

                    spaceRangeContainer.removeAttr("hidden");
                }
            });
        }
    });

    function calculateFloorSpace(typeConstant, numberOfPeople) {
        const result = Math.round(typeConstant * numberOfPeople / 10) * 10;
        return result;
    }
}(jQuery));
